<template>
    <div>
        <app-header messages="我" detail="注册流程" pathName="/person/me" pathTo="/person/registerprocess"></app-header>
        <!--shopcart-->
        <div class="w">
            <div class="wb">
                <div class="news_show bg_w_s">
                    <h1>注册认证</h1>
                    <div class="news_show_l">
                        <p>1、登录www.zuluoji.com</p>
                        <p>2、点击页面右侧的注册</p>
                        <p><img src="/static/images/qa_01.jpg"></p>
                        <p>3、点击注册后，系统会提示您输入手机号来完成注册。输入手机号之后点击获取验证码，当手机收到验证码后，请将验证码输入相对应位置。验证码输入完成后点击注册即可。 </p>
                        <p><img src="/static/images/qa_02.jpg"></p>
                        <p>4点击注册后，系统会提示您设置用户名和密码。 </p>
                        <p><img src="/static/images/qa_03.jpg"></p>
                        <p>5点击完成注册后系统会提示您，已注册，请激活账户。 </p>
                        <p><img src="/static/images/qa_04.jpg"></p>
                        <p>6、激活账户需要企业用户填写公司名称、统一社会信用代码、法人姓名、法人身份证号、企业类型、企业规模。还需要上传企业的营业执照照片、法人身份证照片、授权书。（注：授权书在网站上下载，加盖企业公章后上传）。然后再次输入手机号，验证码后提交审核。  </p>
                        <p><img src="/static/images/qa_05.jpg"></p>
                        <p>7、提交后系统会提示您认证审核中，请您耐心等待。待后台工作人员审核后，您可以正常使用账户。</p>
                        <p><img src="/static/images/qa_06.jpg"></p>
                    </div>
                    <Right></Right>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <!--shopcart end-->

        <app-footer></app-footer>
    </div>
</template>
<script>
    import AppHeader from '../../components/common/Header.vue'
    import AppFooter from '../../components/common/Footer.vue'

    import Right from '../../components/common/Right.vue'
    export default {
        name: "registerprocess",
        props:['messages','detail'],
        components: {
            AppHeader,
            AppFooter,

            Right
        }
    }
</script>



// WEBPACK FOOTER //
// src/center/person/registerprocess.vue